import React, { useState, useEffect, useContext } from "react";

import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import EntriesDataContext from "../../../context/EntriesDataContext";
import "./TaskSummary.css";

import check from "../../../assets/check.svg";
import file from "../../../assets/file.svg";

const TaskSummary = () => {
  const [complete, setComplete] = useState(0);
  const [incomplete, setIncomeplete] = useState(0);
  const { redirectId } = useContext(EntriesDataContext);
  const axiosPrivate = useAxiosPrivate();

  useEffect(() => {
    axiosPrivate
      .get("/dashboard/complete_box/")
      .then((res) => {
        setIncomeplete(res.data.data[0].dcount);
        setComplete(res.data.data[1].dcount);
      })
      .catch((err) => console.log(err));
  }, [redirectId]);

  return (
    <div className="operator-task-container">
      <p className="operator-task-header">Task Summary</p>

      <section className="operator-task-flex-container">
        <div className="operator-task-con operator-task-con-1">
          <span className="con-logo con-1-logo">
            <img src={check} alt="logo" className="logo-img" />
          </span>
          <h3 className="num con-1-num">{complete}</h3>
          <p className="text con-1-text">Claims Completed</p>
        </div>

        <div className="operator-task-con operator-task-con-2">
          <span className="con-logo con-2-logo">
            <img src={file} alt="logo" className="logo-img" />
          </span>
          <h3 className="num con-2-num">{incomplete}</h3>
          <p className="text con-2-text">Incomplete Claims</p>
        </div>
      </section>
    </div>
  );
};

export default TaskSummary;
